<template>
    <ac-modal :title="'Send Reminder'" :size-class="'modal-md'" ref="modalRef">
        <template>
            <form v-if="widgetReady">
                <div class="row">
                    <div class="info-board info-board-blue" style="margin: 0 0 20px 0">
                        <p>Do you want to send a reminder to {{ vm.displayName }} to notify them of a pending invoice?</p>
                    </div>
                </div>
            </form>
        </template>
        <template slot="buttons">
            <ac-button class="btn btn-sm btn-red margin-gutters" :action="closeModal">
                CANCEL
            </ac-button>
            <ac-button class="btn btn-sm btn-green margin-gutters" :action="sendReminderEmail">
                SEND
            </ac-button>
        </template>
    </ac-modal>
</template>

<script>
import { api } from "../../global/framework/api.js";
import { common } from "../../global/common.js";
import { notifications } from "../../global/notifications.js";

export default {
    name: "SendInvoiceReminderEmailModal",
    data() {
        return {
            vm: { invoiceId: Number, displayName: String, consumerId: Number},
            widgetReady: false
        }
    },
    methods: {
        async showModal({invoiceId: invoiceId, displayName: displayName, consumerId: consumerId, companyId: companyId}) {      
            this.vm = {invoiceId, displayName, consumerId, companyId};
            this.widgetReady = true;
            this.$refs.modalRef.open();
        },
        closeModal() {
            this.$refs.modalRef.close();
        },
        async sendReminderEmail() {
            let result;
            if (this.vm.consumerId) {
                result = await api.post("Invoice", 'SendMemberInvoiceReminder/' + this.vm.invoiceId, {}, true);
            } else if (this.vm.companyId) {
                result = await api.post("Invoice", 'SendGroupInvoiceReminder/' + this.vm.invoiceId, {}, true);
            }

            if (result.data) {
                notifications.show({ title: "Success!", message: "Successfully sent email reminder to " + this.vm.displayName + "." }, common.ACRESSA_NOTIFICATIONS.SUCCESS);
            }
            else{
                notifications.show({ title: "Failure!", message: "Failed to send email reminder to " + this.vm.displayName + "." }, common.ACRESSA_NOTIFICATIONS.ERROR);
            }
            this.closeModal();
        }
    }
}
</script>